import React, { useState } from "react";
import { FcAlphabeticalSortingAz, FcAlphabeticalSortingZa } from "react-icons/fc";
import { elakayAutoText } from "./dataElakay";
import { orderStatusLabel } from "../pages/purchased/OrderStatusBadge";
import { SELLER_ORDER_STATUSES } from "./sellerOrderStatuses";



const FiltersOrders = props =>{
    const { 
        infoSource,
        laguangeElakay,
        limit, 
        setLimit,
        setFiltOrders,
        setShowFilterOrder,
        filtOrders
    }=props

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes filterEnter {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

/* ===== FILTER CONTAINER ===== */

.filters-premium {
    animation: filterEnter 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* ===== FILTER SECTION ===== */

.filter-section-premium {
    margin-bottom: 1.5rem;
}

/* Section Header */
.filter-section-header {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.08) 0%, 
            rgba(0, 164, 216, 0.05) 100%
        );
    padding: 0.875rem 1.25rem;
    border-radius: 12px;
    margin-bottom: 1rem;
    box-shadow: 0 2px 8px rgba(0, 115, 153, 0.08);
}

.filter-section-header h5 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 50%,
        #00a4d8 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    font-size: 1rem;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    animation: shimmerGlow 4s linear infinite;
}

.filter-section-header h5::before {
    content: '';
    width: 3px;
    height: 18px;
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    border-radius: 2px;
}

/* ===== RADIO BUTTONS PREMIUM ===== */

.filter-option-premium {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    margin: 0.5rem 0;
    border-radius: 12px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    border: 2px solid rgba(226, 232, 240, 0.6);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.filter-option-premium::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.05) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.filter-option-premium:hover {
    border-color: rgba(0, 164, 216, 0.3);
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 115, 153, 0.1);
}

.filter-option-premium:hover::before {
    opacity: 1;
}

/* Radio Input */
.filter-radio-premium {
    width: 20px;
    height: 20px;
    margin: 0;
    margin-right: 0.875rem;
    cursor: pointer;
    appearance: none;
    border: 2px solid rgba(148, 163, 184, 0.5);
    border-radius: 50%;
    position: relative;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.filter-radio-premium:checked {
    border-color: #007399;
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    box-shadow: 
        0 0 0 4px rgba(0, 164, 216, 0.15),
        0 2px 8px rgba(0, 115, 153, 0.3);
}

.filter-radio-premium:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 6px;
    height: 6px;
    background: white;
    border-radius: 50%;
}

.filter-radio-premium:hover {
    border-color: #007399;
    box-shadow: 0 0 0 4px rgba(0, 164, 216, 0.1);
}

/* Checked State for Container */
.filter-option-premium:has(.filter-radio-premium:checked) {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.08) 0%, 
            rgba(0, 164, 216, 0.05) 100%
        );
    border-color: rgba(0, 164, 216, 0.4);
    box-shadow: 0 4px 16px rgba(0, 115, 153, 0.15);
}

/* Label */
.filter-label-premium {
    color: #1e293b;
    font-weight: 600;
    font-size: 0.9375rem;
    cursor: pointer;
    margin: 0;
    flex: 1;
    transition: color 0.3s ease;
}

.filter-option-premium:hover .filter-label-premium {
    color: #007399;
}

/* ===== SELECT PREMIUM ===== */

.select-container-premium {
    margin: 1rem 0;
}

.select-premium {
    width: 100%;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    border: 2px solid rgba(226, 232, 240, 0.8);
    border-radius: 12px;
    padding: 0.875rem 3rem 0.875rem 1.25rem;
    font-size: 1rem;
    color: #1e293b;
    font-weight: 500;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 2px 8px rgba(0, 0, 0, 0.05),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23007399' d='M8 11L3 6h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
}

.select-premium:focus {
    outline: none;
    border-color: rgba(0, 164, 216, 0.6);
    background: white;
    box-shadow: 
        0 0 0 4px rgba(0, 164, 216, 0.1),
        0 4px 16px rgba(0, 115, 153, 0.12);
    transform: translateY(-2px);
}

.select-premium:hover {
    border-color: rgba(0, 164, 216, 0.4);
}

.select-premium option {
    padding: 0.75rem;
    background: white;
    color: #1e293b;
    font-weight: 500;
}

/* ===== BUTTONS PREMIUM ===== */

.filter-buttons-premium {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 2px solid rgba(226, 232, 240, 0.5);
}

.btn-filter-premium {
    flex: 1;
    padding: 0.875rem 1.5rem;
    border-radius: 14px;
    font-weight: 700;
    font-size: 1rem;
    border: none;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    position: relative;
    overflow: hidden;
}

.btn-filter-premium::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

/* Clear Button */
.btn-clear-premium {
    background: 
        linear-gradient(135deg, 
            rgba(248, 250, 252, 0.98) 0%, 
            rgba(241, 245, 249, 0.95) 100%
        );
    color: #475569;
    box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.btn-clear-premium::before {
    background: linear-gradient(135deg, 
        rgba(148, 163, 184, 0.1) 0%, 
        transparent 100%
    );
}

.btn-clear-premium:hover {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    color: #1e293b;
}

.btn-clear-premium:hover::before {
    opacity: 1;
}

/* Apply Button */
.btn-apply-premium {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    color: white;
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.btn-apply-premium::before {
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.2) 0%, 
        transparent 100%
    );
}

.btn-apply-premium:hover {
    background: linear-gradient(135deg, #006b8a 0%, #007399 100%);
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 115, 153, 0.4);
}

.btn-apply-premium:hover::before {
    opacity: 1;
}

/* Button Icons */
.btn-filter-premium::after {
    font-size: 1.125rem;
}

.btn-clear-premium::after {
    content: '🗑️';
}

.btn-apply-premium::after {
    content: '✓';
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {
    .filter-section-header {
        padding: 0.75rem 1rem;
    }

    .filter-section-header h5 {
        font-size: 0.9375rem;
    }

    .filter-option-premium {
        padding: 0.625rem 0.875rem;
        margin: 0.375rem 0;
    }

    .filter-label-premium {
        font-size: 0.875rem;
    }

    .select-premium {
        padding: 0.75rem 2.5rem 0.75rem 1rem;
        font-size: 0.9375rem;
    }

    .filter-buttons-premium {
        flex-direction: column;
        gap: 0.75rem;
    }

    .btn-filter-premium {
        padding: 0.75rem 1.25rem;
        font-size: 0.9375rem;
    }
}

/* ===== SORT DIRECTION (ASC / DESC) ===== */

.sort-direction-toggle {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.25rem;
}

.sort-direction-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 1.25rem;
    border-radius: 12px;
    border: 2px solid rgba(226, 232, 240, 0.6);
    background:
        linear-gradient(135deg,
            rgba(255, 255, 255, 0.98) 0%,
            rgba(248, 250, 252, 0.95) 100%
        );
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.sort-direction-btn:hover {
    border-color: rgba(0, 164, 216, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 115, 153, 0.1);
}

.sort-direction-btn.active {
    border-color: #00a4d8;
    background:
        linear-gradient(135deg,
            rgba(0, 164, 216, 0.12) 0%,
            rgba(0, 115, 153, 0.08) 100%
        );
    box-shadow: 0 2px 8px rgba(0, 115, 153, 0.15);
}

/* ===== ACCESSIBILITY ===== */

.filter-radio-premium:focus-visible,
.select-premium:focus-visible,
.btn-filter-premium:focus-visible,
.sort-direction-btn:focus-visible {
    outline: 3px solid #00a4d8;
    outline-offset: 2px;
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
        animation: none !important;
        transition: none !important;
    }
}
`;

    // value = the stored order status sent to the API; name = a stable DOM id; label = display text.
    let status = [
        {value: "none", name: "none", get label() { return elakayAutoText("h_6405179d241bf8", "All statuses"); }},
        ...SELLER_ORDER_STATUSES.map((value) => ({ value, name: `order-status-${value.replace(/\s+/g, "-").toLowerCase()}`, label: orderStatusLabel(value) })),
    ];

    let date = ['days', 'months', 'years'];
    const PERIOD_UNIT_LABELS = { days: ["h_ord_filter_days", "Days"], months: ["h_ord_filter_months", "Months"], years: ["h_ord_filter_years", "Years"] };
    
    const [orderStatus, setOrderStatus] = useState(filtOrders.orderStatus);
    const [orderDate, setOrderDate] = useState(filtOrders.orderDate);
    const [myd, setmyd] = useState(filtOrders.myd);
    const [nlimit, setNlimit] = useState(limit);
    const [asc, setAsc] = useState(filtOrders.asc || 'desc');

    const handlechange = event =>{
        setmyd(event.target.value)
    }

    const handlPageOrder = event =>{
        setNlimit(event.target.value)
    }

    const handleDate = event =>{
        let value = event.target.value
        if(value === "days"){
            setmyd(15)
        }else if(value === "months"){
            setmyd(6)
        } else if(value === "years"){
            setmyd(2024)
        }
        setOrderDate(value)
    }
    
    const btnfilter = ()=>{
        setLimit(nlimit)
        setShowFilterOrder(false)
        setFiltOrders({orderStatus, orderDate, myd, asc})
    }

    const btnClrfilter = ()=>{
        setLimit(3)
        setShowFilterOrder(false)
        setFiltOrders({orderStatus: 'none',  orderDate: 'months',  myd: 6, asc: 'desc'})
    }

    const ascDescForm = ()=>{
        return(
            <div className="filter-section-premium">
                <div className="filter-section-header">
                    <h5>
                        {infoSource.language(infoSource, "title", "descAsce")}
                    </h5>
                </div>
                <div className="sort-direction-toggle">
                    <button
                        type="button"
                        className={`sort-direction-btn ${asc === 'asc' ? 'active' : ''}`}
                        onClick={()=>setAsc('asc')}
                        aria-label={elakayAutoText("h_filersorder_asc", "Ascending")}
                    >
                        <FcAlphabeticalSortingAz />
                    </button>
                    <button
                        type="button"
                        className={`sort-direction-btn ${asc === 'desc' ? 'active' : ''}`}
                        onClick={()=>setAsc('desc')}
                        aria-label={elakayAutoText("h_filersorder_desc", "Descending")}
                    >
                        <FcAlphabeticalSortingZa />
                    </button>
                </div>
            </div>
        )
    }

    const statusForm = ()=>{
        return(
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).status}
                    </h5>
                </div>
                {status?.map((p, i) => (
                    <label key={i} className="filter-option-premium" htmlFor={p.name}>
                        <input
                            onChange={()=>setOrderStatus(p.value)}
                            name={elakayAutoText("h_48a3661d846478", "status")}
                            type="radio"
                            className="filter-radio-premium"
                            checked={p.value === orderStatus}
                            id={p.name}
                        />
                        <span className="filter-label-premium">
                            {p.label}
                        </span>
                    </label>
                ))}
            </div>
        )
    }
    
    const dateForm = ()=>{
        return(
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).filterdate}
                    </h5>
                </div>
                {date?.map((p, i) => (
                    <label key={i} className="filter-option-premium" htmlFor={p}>
                        <input
                            onChange={handleDate}
                            value={p}
                            name={elakayAutoText("h_e927d0677c7724", "date")}
                            type="radio"
                            className="filter-radio-premium"
                            checked={p === orderDate}
                            id={p}
                        />
                        <span className="filter-label-premium">
                            {PERIOD_UNIT_LABELS[p] ? elakayAutoText(...PERIOD_UNIT_LABELS[p]) : p}
                        </span>
                    </label>
                ))}
            </div>
        )
    }
    
    const orderBypageselect = ()=>{
        const pageOrder = []
        const startNumber = 1
        const endNumber = 20;

        for (let number = startNumber; number <= endNumber; number++) {
            pageOrder.push(number);
        }
        
        return (
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).orderPage}
                    </h5>
                </div>
                <div className="select-container-premium">
                    <select value={nlimit} onChange={handlPageOrder} className="select-premium">
                        <option>
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).selOrderPage}
                        </option>
                        {pageOrder?.map((c, i) => (
                            <option key={i} value={c}>
                                {c} {infoSource.laguangeElakay('label', infoSource.languageAPI).items}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        )
    }

    const daySelect = ()=>{
        const allDays = []
        const startDay = 1
        const endDay = 30;

        for (let day = startDay; day <= endDay; day++) {
            allDays.push(day);
        }
        
        return (
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).filterDays}
                    </h5>
                </div>
                <div className="select-container-premium">
                    <select value={myd} onChange={handlechange} className="select-premium">
                        <option>
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).selectdays}
                        </option>
                        {allDays?.map((c, i) => (
                            <option key={i} value={c}>
                                {c} {c === 1 ? elakayAutoText("h_auto_day_singular", "day") : elakayAutoText("h_auto_day_plural", "days")}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        )
    }

    const monthsSelect = ()=>{
        const allMonths = []
        const startMonth = 1
        const endMonth = 12;

        for (let month = startMonth; month <= endMonth; month++) {
            allMonths.push(month);
        }
        
        return (
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).filterMonths}
                    </h5>
                </div>
                <div className="select-container-premium">
                    <select value={myd} onChange={handlechange} className="select-premium">
                        <option>
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).selectmonth}
                        </option>
                        {allMonths?.map((c, i) => (
                            <option key={i} value={c}>
                                {c} {c === 1 ? elakayAutoText("h_auto_month_singular", "month") : elakayAutoText("h_auto_month_plural", "months")}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        )
    }

    const yearsSelect = ()=>{
        const allyears = []
        var currentTime = new Date()
        var curYear = currentTime.getFullYear()
        const startYear = curYear - 6
        const endYear = curYear;

        for (let year = endYear; year >= startYear; year--) {
            allyears.push(year);
        }
        
        return (
            <div className="filter-section-premium"> 
                <div className="filter-section-header">
                    <h5>
                        {infoSource.laguangeElakay('title', infoSource.languageAPI).filteryears}
                    </h5>
                </div>
                <div className="select-container-premium">
                    <select value={myd} onChange={handlechange} className="select-premium">
                        <option>
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).selectyear}
                        </option>
                        {allyears?.map((c, i) => (
                            <option key={i} value={c}>
                                {c}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        )
    }

    const btnForm = ()=>{
        return(
            <div className="filter-buttons-premium"> 
                <button className="btn-filter-premium btn-clear-premium" onClick={btnClrfilter}>
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).clearfilter}
                </button>
                <button className="btn-filter-premium btn-apply-premium" onClick={btnfilter}>
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).setfilter}
                </button>
            </div>
        )
    }

    return (
        <div className="filters-premium">
            <style>{premiumStyles}</style>
            {orderBypageselect()}
            {statusForm()}
            {dateForm()}
            {orderDate === 'days' && daySelect()}
            {orderDate === 'months' && monthsSelect()}
            {orderDate === 'years' && yearsSelect()}
            {ascDescForm()}
            {btnForm()}
        </div>
    )
}

export default FiltersOrders;
